module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK2.12ef6866.jpg";